import React, {Component} from "react";
import PropTypes from "prop-types";

class SelectionButton extends Component {

  onClick = (e) => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {

    let color;
    if (this.props.color) {
      color = this.props.color;
    } else {
      color = 'bg-green-500 hover:bg-green-600';
    }

    return <button className={"mb-4 inline-flex items-center px-4 py-2 " + color + "text-black font-semibold rounded transition m-2"} onClick={this.onClick}>
      {this.props.text}
    </button>;
  }
}

SelectionButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string
}
export default SelectionButton;
